module.exports = __webpack_public_path__ + "img/model3.c4c2f11d.png";